import React from 'react';
import { motion } from 'framer-motion';
interface FloatingWhatsAppProps {
  href: string;
  onClick?: () => void;
}
export function FloatingWhatsApp({
  href,
  onClick
}: FloatingWhatsAppProps) {
  return <a href={href} target="_blank" rel="noopener noreferrer" onClick={onClick} aria-label="Papia ku nos via WhatsApp" className="fixed bottom-5 right-5 md:bottom-7 md:right-7 z-50 group" data-id="element-46">
      <span className="relative flex items-center justify-center" data-id="element-47">
        {/* Pulsing rings */}
        <motion.span className="absolute inline-flex h-full w-full rounded-full bg-[#25D366]" animate={{
        scale: [1, 1.8],
        opacity: [0.6, 0]
      }} transition={{
        duration: 1.8,
        repeat: Infinity,
        ease: 'easeOut'
      }} data-id="element-48" />
        <motion.span className="absolute inline-flex h-full w-full rounded-full bg-[#25D366]" animate={{
        scale: [1, 1.8],
        opacity: [0.6, 0]
      }} transition={{
        duration: 1.8,
        repeat: Infinity,
        ease: 'easeOut',
        delay: 0.9
      }} data-id="element-49" />

        {/* The button — blinking glow */}
        <motion.span className="relative flex items-center justify-center w-15 h-15 md:w-16 md:h-16 rounded-full bg-[#25D366] text-white shadow-lg" style={{
        width: '3.75rem',
        height: '3.75rem'
      }} animate={{
        boxShadow: ['0 0 0px rgba(37,211,102,0.4)', '0 0 28px rgba(37,211,102,0.9)', '0 0 0px rgba(37,211,102,0.4)'],
        scale: [1, 1.06, 1]
      }} transition={{
        duration: 1.4,
        repeat: Infinity,
        ease: 'easeInOut'
      }} whileHover={{
        scale: 1.12
      }} data-id="element-50">
          <svg viewBox="0 0 24 24" className="w-8 h-8 md:w-9 md:h-9 fill-current" aria-hidden="true" data-id="element-51">
            <path d="M.057 24l1.687-6.163a11.867 11.867 0 01-1.587-5.946C.16 5.335 5.495 0 12.05 0a11.817 11.817 0 018.413 3.488 11.824 11.824 0 013.48 8.414c-.003 6.557-5.338 11.892-11.893 11.892a11.9 11.9 0 01-5.688-1.448L.057 24zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884a9.821 9.821 0 001.529 5.262l-.999 3.648 3.748-.981zm11.387-5.464c-.074-.124-.272-.198-.57-.347-.297-.149-1.758-.868-2.031-.967-.272-.099-.47-.149-.669.149-.198.297-.768.967-.941 1.165-.173.198-.347.223-.644.074-.297-.149-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.521.151-.172.2-.296.3-.495.099-.198.05-.372-.025-.521-.075-.148-.669-1.611-.916-2.206-.242-.579-.487-.501-.669-.51l-.57-.01c-.198 0-.52.074-.792.372s-1.04 1.016-1.04 2.479 1.065 2.876 1.213 3.074c.149.198 2.095 3.2 5.076 4.487.709.306 1.263.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.247-.694.247-1.289.173-1.413z" data-id="element-52" />
          </svg>
        </motion.span>
      </span>
    </a>;
}